import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, registerables, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import 'chartjs-adapter-date-fns';

// Register necessary components from Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ...registerables // Spread registerables directly
);

// Define alert thresholds for temperature, humidity, and pH
const TEMP_HIGH = 25.0;
const TEMP_LOW = 18.0;
const HUMIDITY_HIGH = 68.0;
const HUMIDITY_LOW = 40.0;
const PH_HIGH = 6.6;
const PH_LOW = 5.6;

const LineChart = ({ actualData, predictedData, label, timestamps }) => {
  console.log("Actual Sensor Data: ", actualData);
  console.log("Predicted Data: ", predictedData);

  // Determine the appropriate upper and lower thresholds based on the label
  let upperThreshold, lowerThreshold;
  if (label === 'Temperature') {
    upperThreshold = TEMP_HIGH;
    lowerThreshold = TEMP_LOW;
  } else if (label === 'Humidity') {
    upperThreshold = HUMIDITY_HIGH;
    lowerThreshold = HUMIDITY_LOW;
  } else if (label === 'pH Level') {
    upperThreshold = PH_HIGH;
    lowerThreshold = PH_LOW;
  }

  const chartData = {
    labels: timestamps, // Timestamps for x-axis
    datasets: [
      {
        label: `${label} (Actual)`,
        data: actualData, // Actual data
        fill: false,
        borderColor: 'rgba(75,192,192,1)', // Solid line for actual data
        tension: 0.1,
      },
      {
        label: `${label} (Predicted)`,
        data: predictedData, // Predicted data
        fill: false,
        borderColor: 'rgba(255,99,132,1)', // Different color for predicted data
        borderDash: [5, 5], // Dashed line for predicted data
        tension: 0.1,
      },
      {
        label: `${label} Upper Threshold`,
        data: timestamps.map(() => upperThreshold), // Constant value for the upper threshold
        fill: false,
        borderColor: 'rgba(255,0,0,0.5)', // Red line for upper threshold
        borderDash: [10, 5], // Dashed line for the threshold
        pointRadius: 0, // Hide points
      },
      {
        label: `${label} Lower Threshold`,
        data: timestamps.map(() => lowerThreshold), // Constant value for the lower threshold
        fill: false,
        borderColor: 'rgba(0,0,255,0.5)', // Blue line for lower threshold
        borderDash: [10, 5], // Dashed line for the threshold
        pointRadius: 0, // Hide points
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: 'time', // Use time-based x-axis
        time: {
          unit: 'minute', // Adjust the time unit based on your data
          displayFormats: {
            minute: 'MMM d, h:mm a', // Custom format for the x-axis timestamps
          },
        },
        title: {
          display: true,
          text: 'Timestamps',
        },
      },
      y: {
        title: {
          display: true,
          text: label, // Label for y-axis
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default LineChart;